import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  Container,
  Row,
  Col,
  Form,
  Card,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import { getAgent, updateAgent } from "../../store/slices/agent";
import { emailregex, mobileregex } from "../../utils/Regex";
import { toast } from "react-toastify";
import { useNavigate, Link, useParams } from "react-router-dom";
import Select from "react-select";

const stateOptions = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];

export default function EditAgent() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { id } = useParams();
  const serviceOptions = [
    // { value: "VEHICLE", label: "Vehicle" },
    { value: "TRAVEL AGENT", label: "Travel Agent" },
    // { value: "FERRY", label: "Ferry" },
  ];

  const initialform = {
    name: "",
    mobileNumber: "",
    email: "",
    address: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    gstNumber: "",
    panNumber: "",
    notes: "",
  };

  const [form, setForm] = useState(initialform);

  const [service, setService] = useState();

  const [submitloading, setsubmitLoading] = useState(false);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (id) {
      dispatch(getAgent({ id }))
        .unwrap()
        .then((res) => {
          const agent = res?.agents?.[0];

          setForm({
            name: agent.name || "",
            mobileNumber: agent.mobileNumber || "",
            email: agent.email || "",
            address: agent.address || "",
            city: agent.city || "",
            state: agent.state || "",
            country: agent.country || "",
            pincode: agent.pincode || "",
            gstNumber: agent.gstNumber || "",
            panNumber: agent.panNumber || "",
            notes: agent.notes || "",
          });

          setService(agent.services[0] || "");
        })
        .catch(() => {
          toast.error("Failed to fetch vendor");
        });
    }
  }, [id, dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;
    let error = "";

    if (["gstNumber", "panNumber"].includes(name)) {
      updatedValue = value.toUpperCase();
    }

    const gstRegex =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    // Company Name
    if (name === "name") {
      if (!updatedValue.trim()) {
        error = "Please enter company name";
      } else if (!/^[a-zA-Z0-9][\s\S]*$/.test(updatedValue)) {
        error = "Company name must contain letters only";
      }
    }

    // mobilenumber

    if (name === "mobileNumber") {
      if (!updatedValue) {
        error = "Please enter mobile number";
      } else if (!mobileregex.test(updatedValue)) {
        error = "Enter valid 10-digit mobile number";
      }
    }

    // email
    if (name === "email") {
      const value = updatedValue;

      if (!value.trim()) {
        error = "Please enter email";
      } else if (value.includes(" ")) {
        error = "Email should not contain spaces";
      } else if (value.includes("*")) {
        error = "Masked email is not allowed";
      } else if (!emailregex.test(value)) {
        error = "Please enter valid Email Address";
      } else {
        error = "";
      }
    }

    // pincode
    if (name === "pincode") {
      if (!/^\d{6}$/.test(updatedValue)) error = "Pincode must be 6 digits";
    }

    // Service
    if (name === "service") {
      if (!value) {
        error = "Please select service";
      }
    }

    // Address ---- >
    if (name === "address") {
      if (!updatedValue.trim()) {
        error = "Please enter address";
      }
    }

    // City <-----
    if (name === "city") {
      if (!updatedValue.trim()) {
        error = "Please enter city";
      }
    }

    // State --->
    if (name === "state") {
      if (!updatedValue.trim()) {
        error = "Please select state";
      }
    }

    // Country <-----
    if (name === "country") {
      if (!updatedValue.trim()) {
        error = "Please enter country";
      }
    }

    // GST ---- >
    if (name === "gstNumber") {
      if (updatedValue && !gstRegex.test(updatedValue)) {
        error = "Invalid GST Number";
      }
    }

    if (name === "panNumber") {
      if (updatedValue && !panRegex.test(updatedValue)) {
        error = "Invalid PAN Number";
      }
    }

    setForm((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const validate = () => {
    let newErrors = {};

    const gstRegex =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    if (!form.name.trim()) newErrors.name = "Please enter company name";

    if (!mobileregex.test(form.mobileNumber))
      newErrors.mobileNumber = "Please enter valid mobile number";

    if (!emailregex.test(form.email))
      newErrors.email = "Please enter valid email";

    if (!form.address.trim()) newErrors.address = "Please enter address";

    if (!form.city.trim()) newErrors.city = "Please enter city";

    if (!form.state.trim()) newErrors.state = "Please select state";

    if (!form.country.trim()) newErrors.country = "Please enter country";

    if (!/^\d{6}$/.test(form.pincode))
      newErrors.pincode = "Pincode must be 6 digits";

    if (!service.length) newErrors.service = "Please select service";

    /* OPTIONAL FORMAT VALIDATION */

    if (form.gstNumber.trim() && !gstRegex.test(form.gstNumber))
      newErrors.gstNumber = "Invalid GST Number";

    if (form.panNumber.trim() && !panRegex.test(form.panNumber))
      newErrors.panNumber = "Invalid PAN Number";

    if (form.notes && form.notes.length > 200)
      newErrors.notes = "Maximum 200 characters allowed";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setsubmitLoading(true);

    try {
      const payload = {
        id,
        ...form,
        services: service,
      };

      await dispatch(updateAgent(payload)).unwrap();
      toast.success("Agent update Successfully ");
      navigate("/admin/agent");
      setForm(initialform);

      setErrors({});
    } catch (error) {
      toast.error(error || "Failed to edit agent");
    } finally {
      setsubmitLoading(false);
    }
  };

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>
          <Link to="/admin/agent" className="breadcrumb-link active">
            Agents
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span className="breadcrumb-link inactive">Edit</span>
        </div>
      </div>
      <Container className="mt-4">
        <Card className="shadow-sm p-4" style={{ border: "none" }}>
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Company Name</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter company name"
                        value={form.name}
                        maxLength={50}
                        onChange={handleChange}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.name}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Mobile Number</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="mobileNumber"
                        maxLength={10}
                        placeholder="Enter mobile number"
                        value={form.mobileNumber}
                        onChange={(e) => {
                          if (/^\d*$/.test(e.target.value)) handleChange(e);
                        }}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.mobileNumber}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="email"
                        placeholder="Enter emaill"
                        value={form.email}
                        onChange={handleChange}
                        maxLength={75}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.email}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Service</Form.Label>

                    <Select
                      options={serviceOptions}
                      value={
                        serviceOptions.find(
                          (option) => option.value === service,
                        ) || null
                      }
                      onChange={(selectedOption) => {
                        setService(selectedOption ? selectedOption.value : "");

                        setErrors((prev) => ({
                          ...prev,
                          service: "",
                        }));
                      }}
                      placeholder="Select Services"
                    />

                    <small className="text-danger">{errors.service}</small>
                    <small className="text-danger">{errors.service}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address</Form.Label>
                    <InputGroup>
                      <Form.Control
                         as="textarea"
                        name="address"
                        placeholder="Enter Address"
                        value={form.address}
                        onChange={handleChange}
                        maxLength={400}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.address}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>City</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="city"
                        placeholder="Enter city name"
                        value={form.city}
                        onChange={handleChange}
                        maxLength={30}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.city}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>State</Form.Label>
                    <Select
  options={stateOptions.map((state) => ({
    value: state,
    label: state,
  }))}
  value={
    form.state
      ? { value: form.state, label: form.state }
      : null
  }
  onChange={(selectedOption) => {
    setForm((prev) => ({
      ...prev,
      state: selectedOption ? selectedOption.value : "",
    }));

    setErrors((prev) => ({
      ...prev,
      state: "",
    }));
  }}
  placeholder="Select State"
/>  
                    <small className="text-danger">{errors.state}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Country</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="country"
                        placeholder="Enter country name"
                        value={form.country}
                        onChange={handleChange}
                        maxLength={30}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.country}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Pincode</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="pincode"
                        maxLength={6}
                        placeholder="Enter pincode"
                        value={form.pincode}
                        onChange={(e) => {
                          if (/^\d*$/.test(e.target.value)) handleChange(e);
                        }}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.pincode}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>GST Number</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="gstNumber"
                        maxLength={15}
                        placeholder="Enter GST number"
                        value={form.gstNumber}
                        onChange={handleChange}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.gstNumber}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>PAN</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="panNumber"
                        maxLength={10}
                        placeholder="Enter PAN"
                        value={form.panNumber}
                        onChange={handleChange}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.panNumber}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Notes</Form.Label>
                    <InputGroup>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="notes"
                        placeholder="Enter Notes (Optional)"
                        value={form.notes}
                        onChange={handleChange}
                        maxLength={300}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.notes}</small>
                  </Form.Group>
                </Col>
              </Row>

              {/* Buttons */}
              <div className="text-center d-flex justify-content-center align-items-center mt-5 mb-5">
                <button
                  type="button"
                  className="cancel-btn me-3"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="submit-btn d-flex align-items-center justify-content-center"
                  disabled={submitloading}
                >
                  {submitloading ? (
                    <>
                      <Spinner
                        animation="border"
                        size="sm"
                        variant="light"
                        className="me-2"
                      />
                      Submitting...
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}
